import {
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';

import LoginPage from '../../../../screens/authentication/login';
import CompanyRegisterPage from '../../../../screens/authentication/company-register';
import SetPasswordPage from '../../../../screens/authentication/set-password';
import AcceptInvitePage from '../../../../screens/authentication/accept-invite';
import { COMPANY_REGISTRATION_ENABLED } from '../../../../constants/constant';

export const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route path="accept-invite" element={<AcceptInvitePage />} />
      <Route path="set-password" element={<SetPasswordPage />} />
      <Route
        path="register-company"
        element={
          COMPANY_REGISTRATION_ENABLED ? (
            <CompanyRegisterPage />
          ) : (
            <Navigate to="/auth/login" replace />
          )
        }
      />
    </Routes>
  );
};
